import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import { IconType } from '../components/atoms/icon/icon';
import viewAppCategories from './viewAppCategories';
import viewAppBlackoutsPostalCodes from './viewAppBlackoutsPostalCodes';
import formAppSportRoomBlackouts from './formAppSportRoomBlackouts';
import viewAppBlackoutCameras from './viewAppBlackoutCameras';

export default {
  attributeName: 'blackoutContentTable',
  

  isDragable: false,
  canOpen: true,
  canEdit: true,
  canCreate: false,
  canRemove: true,
  isMultiSelectable:false,
  newButton:true,
  editURL:'blackoutContent',
  getURL:'blackoutContentPage',
  updateURL:'blackoutContent',
  removeURL:'blackoutContent',
  idAttribute:'contentId',
  deleteRecordText:"You are about to delete a group of configured blackouts. Do you still want to proceed?",
  popupContentFormNew:[formAppSportRoomBlackouts],
  popupContentFormEdit:[formAppSportRoomBlackouts],


  emptyMessage: "There hasn't been a blackout yet.",
  fields: [
    {
      attributeName: 'visibility',
      label: 'Geo-restriction',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Geo-restriction enable/disable of the rule.',
      default: '',
      canEdit: false,
      canCreate: false,
      // width: '12rem',
      exactWidth:'100px'
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Name to identify the rule',
      default: '',
      width: '100%',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
    },
    {
      attributeName: 'countryCode',
      label: 'Country',
      type: FormInputTypes.COUNTRY_FLAG,
      helpText: 'Country from the transaction was made',
      default: '',
      width: '10rem',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
      exactWidth:'120px'

    },
  
    {
      attributeName: 'totalCodes',
      label: 'Postal Codes',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Postal codes in this rule',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
      exactWidth:'250px'

    },
    {
      attributeName: 'contentType',
      label: 'Content type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'if content is live or vod',
      default: '',
      canEdit: false,
      canCreate: false,
      canFilter: false,
      canOrder: false,
      hidden:true,
    },
    {
      attributeName: 'blackout_cameras',
      label: 'Custom Cameras Affected',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: false,
      canFilter: false,
      configFile: viewAppBlackoutCameras,
      default: [],
      helpText: 'If no cameras defined, the content itself will be affected by blackout.',
      className:'d-inline-block col-sm-8',
      visibleWhen:{"field":"contentType","value":"live"},


    },
    // {
    //   attributeName: 'action',
    //   label: 'Action',
    //   type: FormInputTypes.SELECT,
    //   helpText: 'Action of the rule.',
    //   options: [
    //     { name: 'Allow', value: 'allow' },
    //     { name: 'Deny', value: 'deny' },
    //   ],
    //   canEdit: true,
    //   canCreate: false,
    //   width: '10rem',
    // },
  ],
};
